import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconSquareCheck: React.NamedExoticComponent<CentralIconBaseProps> = React.memo(React.forwardRef<SVGSVGElement, CentralIconBaseProps>((props, ref) => {
  return <CentralIconBase {...props} ref={ref} ariaLabel={"square-check, checkbox, check, checkmark, confirm"} maskId="square-filled-radius-0-stroke-1-IconSquareCheck"><path fillRule="evenodd" clipRule="evenodd" d="M3 3H21V21H3V3ZM16.2039 9.75001L15.4968 9.0429L10.9968 13.5429L8.99676 11.5429L8.28965 12.25L10.9968 14.9571L16.2039 9.75001Z" fill="currentColor"/></CentralIconBase>;
}));

export default IconSquareCheck;
